export default __webpack_public_path__ + "static/media/clean_gray.68fbae88.svg";